import { buildRunIdParam } from 'src/common/helpers/GQLRequestsHelper/buildRunIdParam';

import { MfaSessionIssuesFilterOptionsQueryVariables } from '../MfaSessionIssuesFilterOptions.generated';

export const buildMfaSessionIssuesFilterOptionsVariables = (
	sessionId: string
): Partial<MfaSessionIssuesFilterOptionsQueryVariables> => {
	const trimmedSessionId = sessionId.trim();
	if (!trimmedSessionId) {
		return {};
	}

	return {
		runId: buildRunIdParam(trimmedSessionId).runId
	};
};
